<template>
  <div class="scrollable-table" :style="tableStyle">
    <slot />
  </div>
</template>

<script>
export default {
  name: "ScrollableTable",
  props: {
    minWidth: {
      type: String,
      default: "var(--oms-list-table-min-width, 90rem)",
    },
  },
  computed: {
    tableStyle() {
      return {
        "--scrollable-table-min-width": this.minWidth,
      };
    },
  },
};
</script>

<style scoped>
.scrollable-table {
  max-width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  -webkit-overflow-scrolling: touch;
}

.scrollable-table ::v-deep .v-table__overflow {
  max-width: 100%;
  overflow-x: auto !important;
  overflow-y: visible;
  width: 100%;
  -webkit-overflow-scrolling: touch;
}

.scrollable-table ::v-deep table.v-table {
  min-width: var(--scrollable-table-min-width) !important;
  table-layout: fixed !important;
}

.scrollable-table ::v-deep table.v-table th,
.scrollable-table ::v-deep table.v-table td {
  overflow: visible;
  overflow-wrap: break-word;
  white-space: normal;
  word-break: normal;
}
</style>
